"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _APButton = _interopRequireDefault(require("../../../common/APButton"));
var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal"));
var _DeclineModal = _interopRequireDefault(require("./DeclineModal"));
var _EnableMarginModal = _interopRequireDefault(require("./EnableMarginModal"));
var _positionFormatter = require("../../../../helpers/positionFormatter");
var _config = _interopRequireDefault(require("../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var themeClasses = (0, _cssClassesHelper.getBEMClasses)('trade-settings');
var MarginTradingSetting = function MarginTradingSetting(_ref) {
  var openEnableMarginTradingModal = _ref.openEnableMarginTradingModal,
    marginEnabled = _ref.marginEnabled,
    isSpotAccountFrozen = _ref.isSpotAccountFrozen,
    minDepositValue = _ref.minDepositValue,
    baseAssetSymbol = _ref.baseAssetSymbol,
    isVLCheckPassed = _ref.isVLCheckPassed,
    isSpotAccountBalanceValidationPassed = _ref.isSpotAccountBalanceValidationPassed,
    isAllChecksPassed = _ref.isAllChecksPassed,
    isDoubleWarning = _ref.isDoubleWarning;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: themeClasses('margin-box')
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: themeClasses('box-header')
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('Margin Trading'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "divider"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('margin-box-body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('box-body-main-content-container')
  }, /*#__PURE__*/_react["default"].createElement("p", null, t(_config["default"].MarginTrading.cardText)), /*#__PURE__*/_react["default"].createElement("p", {
    className: themeClasses('margin-status')
  }, marginEnabled ? /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    ns: "margin"
  }, "Margin Trading is ", /*#__PURE__*/_react["default"].createElement("strong", null, "enabled")) : /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    ns: "margin"
  }, "Margin Trading is ", /*#__PURE__*/_react["default"].createElement("strong", null, "disabled"))), isAllChecksPassed && !marginEnabled && /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    customClass: themeClasses('submit-button'),
    onClick: function onClick() {
      return openEnableMarginTradingModal(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('Enable'))), isAllChecksPassed && marginEnabled && /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    className: "".concat(themeClasses('view-terms-button'), " clear"),
    type: "button",
    onClick: function onClick() {
      return openEnableMarginTradingModal(true);
    }
  }, t('View Terms & Conditions'))), (isSpotAccountFrozen || !isVLCheckPassed) && !marginEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(themeClasses('warning-container'), " ").concat(themeClasses("warning-container".concat(isDoubleWarning ? '_double' : '')))
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: themeClasses('warning-text-highlighted')
  }, t('You are not eligible for enabling margin trading.')), /*#__PURE__*/_react["default"].createElement("br", null), t('Please contact the support team if you have questions about requisites to enable margin.')), !isSpotAccountBalanceValidationPassed && !marginEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(themeClasses('warning-container'), " ").concat(themeClasses("warning-container".concat(isDoubleWarning ? '_double' : '')))
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: themeClasses('warning-text-highlighted')
  }, t('You do not have enough funds in your spot account to enable margin.')), /*#__PURE__*/_react["default"].createElement("br", null), t('The minimum value in any asset in your spot account converted to {{asset}} must be {{value}}', {
    asset: baseAssetSymbol,
    value: "".concat((0, _positionFormatter.formatValue)(minDepositValue, baseAssetSymbol), " ").concat(baseAssetSymbol)
  }))), /*#__PURE__*/_react["default"].createElement(_EnableMarginModal["default"], null), /*#__PURE__*/_react["default"].createElement(_ConfirmationModal["default"], null), /*#__PURE__*/_react["default"].createElement(_DeclineModal["default"], null));
};
MarginTradingSetting.defaultProps = {
  marginEnabled: false
};
MarginTradingSetting.propTypes = {
  cardText: _propTypes["default"].string.isRequired,
  modalText: _propTypes["default"].string.isRequired,
  openEnableMarginTradingModal: _propTypes["default"].bool.isRequired,
  marginEnabled: _propTypes["default"].bool.isRequired,
  isSpotAccountFrozen: _propTypes["default"].bool.isRequired,
  minDepositValue: _propTypes["default"].string.isRequired,
  baseAssetSymbol: _propTypes["default"].string.isRequired,
  isVLCheckPassed: _propTypes["default"].bool.isRequired,
  isSpotAccountBalanceValidationPassed: _propTypes["default"].bool.isRequired,
  isAllChecksPassed: _propTypes["default"].bool.isRequired,
  isDoubleWarning: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = MarginTradingSetting;